import { FC } from 'react';

import ParsedDataGrid from '@components/parsed-data-grid/ParsedDataGrid';

type LeadParsedGridProps = {
  headers: string[];
  rows: Array<Record<string, any>>;
  rowErrorsById?: Record<string, string[]>;
  totalErrorRows: number;
};

const LeadParsedGrid: FC<LeadParsedGridProps> = ({
  headers,
  rows,
  rowErrorsById,
  totalErrorRows
}) => {
  const title = `${rows.length - totalErrorRows} of ${
    rows.length
  } leads will be uploaded. The remaining ${totalErrorRows} contain errors and must be uploaded separately.`;

  return (
    <div className="flex flex-col gap-y-2">
      <div className="align-middle text-sm font-semibold leading-[100%] text-[#344054]">
        {title}
      </div>
      <ParsedDataGrid
        headers={headers}
        rows={rows}
        rowErrorsById={rowErrorsById}
        className="mt-4"
      />
    </div>
  );
};

export default LeadParsedGrid;
